import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';

import * as CourseActions from './actions';

const courseMeta = handleActions(
  {
    [CourseActions.COURSEINFO_SET_COURSE_DATA]: (state, action) => ({
      ...state,
      ...action.payload,
    }),
    [CourseActions.COURSEINFO_RESET_COURSE_DATA]: () => ({}),
  },
  {}
);
const courseOutlineMeta = handleActions(
  {
    [CourseActions.COURSEINFO_SET_COURSEOUTLINE_DATA]: (state, action) => ({
      ...state,
      ...action.payload,
    }),
    [CourseActions.COURSEINFO_RESET_COURSEOUTLINE_DATA]: () => ({
      courseOutline: [],
    }),
  },
  { courseOutline: [] }
);
const courseItemMeta = handleActions(
  {
    [CourseActions.COURSEINFO_SET_COURSEITEM_DATA]: (state, action) => ({
      ...state,
      ...action.payload,
    }),
    [CourseActions.COURSEINFO_RESET_COURSEITEM_DATA]: () => ({}),
  },
  {}
);

export default combineReducers({
  courseMeta,
  courseOutlineMeta,
  courseItemMeta,
});
